import { render, staticRenderFns } from "./product_6_cs.vue?vue&type=template&id=ac688520&scoped=true"
import script from "./product_6_cs.vue?vue&type=script&lang=js"
export * from "./product_6_cs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac688520",
  null
  
)

export default component.exports